export default __webpack_public_path__ + "static/media/1094.d5e891c0.png";